import { useEffect, useState, FC } from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@mui/material";
import ControlledForm from "Components/ControlledForm";
import ImgPath from "Constants/Imgs";
import React from "react";
import { DropdownArrPropsType, MultiDropDataType } from "DataTypes/Form";
const MultiSelectDropDown: FC<MultiDropDataType> = (
  props: MultiDropDataType
) => {
  const [openDrop, setOpenDrop] = useState(false);
  const [selectedItems, setSelectedItems] = useState<DropdownArrPropsType[]>(
    []
  );
  const [inputValue, setInputValue] = useState<string>("");
  const [allSelectCheck, setAllSelectCheck] = useState(false);

  const {
    id,
    label,
    placeholder,
    dropArr,
    dropValue,
    required,
    onClick,
    width,
    error,
    errorText,
    disableSelectAll,
    disableArr,
    readOnly,
  } = props;

  const handleClick = () => {
    setOpenDrop(openDrop ? false : true);
  };

  useEffect(() => {
    const newArr: DropdownArrPropsType[] = [];
    dropValue?.forEach((el) => {
      const newObj = dropArr?.find((el1) => el1.value == el);
      newObj && newArr.push(newObj);
    });
    setInputValue(newArr.map((el) => el.label).join(", "));
    setSelectedItems(newArr);
  }, [dropValue, dropArr]);

  useEffect(() => {
    handleCheckAll();
  }, [selectedItems]);

  const handleSelect = (obj: DropdownArrPropsType) => {
    const found = selectedItems.find(
      (el: DropdownArrPropsType) => el.id == obj.id
    );
    let newArr;
    if (!found) {
      newArr = [...selectedItems, obj];
    } else {
      newArr = selectedItems.filter((el) => el.id !== obj.id);
    }
    setInputValue(newArr.map((el) => el.label).toString());
    setSelectedItems(newArr);
    onClick && onClick(newArr.map((el) => el.value) || []);
  };

  const handleSelectAll = () => {
    if (allSelectCheck) {
      setInputValue("");
      setSelectedItems([]);
      onClick && onClick([]);
    } else {
      const newArr: DropdownArrPropsType[] = JSON.parse(
        JSON.stringify(dropArr)
      );
      setInputValue(
        newArr.map((el: DropdownArrPropsType) => el.label).toString()
      );
      setSelectedItems(newArr);
      onClick && onClick(newArr.map((el) => el.value) || []);
    }
  };

  const handleCheckAll = () => {
    if (dropArr) {
      let allselect = true;
      for (let i = 0; i < dropArr?.length; i++) {
        const newObj = selectedItems.find(
          (el: DropdownArrPropsType) => el.id == dropArr[i].id
        );
        if (!newObj) {
          allselect = false;
          break;
        }
      }
      setAllSelectCheck(allselect);
    }
  };

  const handleDelete = (item: DropdownArrPropsType) => {
    const updatedItems = selectedItems.filter((el) => el.id !== item.id);
    setSelectedItems(updatedItems);
    onClick && onClick(updatedItems.map((el) => el.value) || []);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        key={id}
        id="checkboxes-tags-demo"
        options={dropArr}
        disableCloseOnSelect
        {...(readOnly && { disabled: readOnly })}
        renderOption={(props, option, { selected }) => (
          <li onClick={() => handleSelect(option)}>
            <Checkbox
              icon={<ImgPath.CheckBoxIcon />}
              checkedIcon={<ImgPath.checkIcon />}
              sx={{ color: "primary.main" }}
              checked={selectedItems?.map((el) => el.id).includes(option.id)}
            />
            {option.label}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            margin="normal"
            {...params}
            label={label}
            required={required}
            error={error}
            helperText={errorText}
            placeholder={selectedItems.length > 0 ? "" : label}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  {selectedItems.slice(0, 4).map((item) => (
                    <Chip
                      key={item.id}
                      label={item.label}
                      onDelete={() => handleDelete(item)}
                      style={{ margin: "2px" }}
                    />
                  ))}
                  {selectedItems.length > 4 && (
                    <Chip
                      label={`+${selectedItems.length - 4}`}
                      style={{ margin: "2px" }}
                    />
                  )}
                </>
              ),
            }}
          />
        )}
        {...(!disableSelectAll && {
          ListboxComponent: (props) => {
            return (
              <List {...props}>
                <ListItem
                  // dense
                  sx={{
                    p: "unset",
                  }}
                  onClick={handleSelectAll}
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={allSelectCheck}
                      onChange={handleSelectAll}
                      sx={{ color: "primary.main" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Select All" />
                </ListItem>
                {props.children}
              </List>
            );
          },
        })}
      />
    </Box>
  );
};
export default MultiSelectDropDown;
